export default __webpack_public_path__ + "static/media/visibility-off-icon.067881b4.svg";